module.exports = __webpack_public_path__ + "static/media/hands.07d3ea78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DashboardCard/ProjectCard/hands.png
// module id = 1909
// module chunks = 0